import type { RouteLocationNormalizedLoaded } from '#vue-router'

export const isOnboardingLogin = (route: RouteLocationNormalizedLoaded) => {
    return route.query.street
}
